import { useEffect, useState } from "react";
import { doc, getDoc } from "../services/mysqlStore";
import { db } from "../services/mysqlStore";

const DEFAULTS = {
  aboutHeroText: "25+ years of delivering exceptional print quality to businesses across Canada.",
  aboutIntroTitle: "Printing Excellence\nSince 1999",
  aboutIntroParagraph1: "Circuit Printing Solutions was founded with one mission: to make professional-quality printing accessible to businesses of all sizes. From our facility in Canada, we serve businesses every year, from sole traders to major brands.",
  aboutIntroParagraph2: "We invest in the latest printing technology and employ experienced print professionals who care about the quality of every job that leaves our building. Whether you need 50 business cards or 50,000 leaflets, we treat every order with the same attention to detail.",
  contactHeroText: "Ready to start your print project? We'd love to hear from you.",
  contactIntroTitle: "Let's Talk Printing",
  contactIntroText: "Whether you need a quote, have a question about artwork, or want to discuss a large print project, our team is here to help.",
};

export function useSiteContent() {
  const [data, setData] = useState(DEFAULTS);
  useEffect(() => {
    getDoc(doc(db, "siteSettings", "siteContent"))
      .then(snap => { if (snap.exists()) setData(prev => ({ ...prev, ...snap.data() })); })
      .catch(() => {});
  }, []);
  return data;
}
